import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function UserModal(props) {

    return (
        <>
            <Button className={`btn ${props.customClasses}`} onClick={() => props.handleShow(props.id)}>
                {typeof props.icon !== "undefined" ? props.icon : props.btnText}
            </Button>

            {
                props.modalItem == props.id &&
                <Modal
                    className='modal'
                    {...props}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={props.show}
                    onHide={props.handleClose}
                >

                    <Modal.Header closeButton>
                        {/* <Modal.Title> */}
                        {/* <div className='d-flex jc-center text-center ai-center modal_header'>
                           <h3>{props.title}</h3>
                        </div> */}
                        {/* </Modal.Title> */}
                    </Modal.Header>

                    <Modal.Body className='modal_body'>
                        {props.children}
                        {/* <div className='mb-4'>
                        <p>{props.priceTitle}</p>
                        <h6>{props.priceText}</h6>
                        <small>{props.price}</small>
                    </div>
                    <div className='mb-4'>
                        <p>{props.availableTitle}</p>
                        <h6>{props.availableText}</h6>
                    </div>
                    <div className='mb-4'>
                        <small>{props.details}</small>
                    </div>
                    <div>
                        <h6>{props.termsCondTitle}</h6>
                        <small>{props.termsCondText}</small>
                    </div> */}
                    </Modal.Body>

                    <Modal.Footer>
                        {/* <div className='modal_btn jc-center m-auto'>
                        <Button className='mx-2 cancel_btn' variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className='mx-2 buynow_btn' variant="primary" onClick={handleClose}>
                            Buy Now
                        </Button>
                    </div> */}
                    </Modal.Footer>

                </Modal>
            }
        </>
    );
}

export default UserModal